import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SvgIcon} from '@mui/material';
import {paths} from 'src/paths';
import {
  boardsRoute,
  dashboardBaseRoute, getCanvasRoute,
  getStartedRoute,
  layoutsRoute,
  medialListRoute,
  mediaSequencesRoute,
  schedulesRoute,
  screensRoute,
  widgetsRoute
} from '../../routes/dashboard';
import localStrings from "../../localStrings";
import useAuth from "../../hooks/useAuth";
// Same icon set as apiborneKiosk/admin-next (src/lib/navigation.ts), so both
// admin UIs share a visual vocabulary: Tv/MonitorPlay for signage, LayoutGrid
// for layouts, Image for medias, CalendarDays for scheduling.
import {
  CalendarDays,
  House,
  Image as ImageIcon,
  LayoutGrid,
  LayoutTemplate,
  Megaphone,
  MonitorPlay,
  Rocket,
  ScreenShare,
  Tv,
  User,
} from 'lucide-react';
import config from "../../conf/config.json";

export const useSections = () => {
  const { t } = useTranslation();
  const {currentBrand} = useAuth();
  const [appItems, setAppItems] = useState([]);

  useEffect(() => {
    setAppItems(getAppItems());
  }, [currentBrand])

  function getAppItems() {
    //const items = [];
    if (currentBrand()) {
      return ([
        {
          title: localStrings.mediaSequences,
          path: "/" + dashboardBaseRoute + "/" + mediaSequencesRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <MonitorPlay/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.devices,
          path: "/" + dashboardBaseRoute + "/" + screensRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <Tv/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.schedules,
          path: "/" + dashboardBaseRoute + "/" + schedulesRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <CalendarDays/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.boards,
          path: "/" + dashboardBaseRoute + "/" + boardsRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <ScreenShare/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.layouts,
          path: "/" + dashboardBaseRoute + "/" + layoutsRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <LayoutTemplate/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.widgets,
          path: "/" + dashboardBaseRoute + "/" + widgetsRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <LayoutGrid/>
            </SvgIcon>
          )
        },
        {
          title: localStrings.mediasList,
          path: "/" + dashboardBaseRoute + "/" + medialListRoute,
          partialMatch: true,
          icon: (
            <SvgIcon fontSize="small">
              <ImageIcon/>
            </SvgIcon>
          )
        },

        // {
        //   title: localStrings.canvas,
        //   path: "/" + dashboardBaseRoute + "/" + getCanvasRoute,
        //   partialMatch: true,
        //   icon: (
        //     <SvgIcon fontSize="small">
        //       <Rocket/>
        //     </SvgIcon>
        //   )
        // },

      ]);
    }
    return [];
  }

  return useMemo(() => {
    return [
      {
        items: [
          {
            title: localStrings.dashboard,
            path: "/" + dashboardBaseRoute,
            partialMatch: false,
            icon: (
              <SvgIcon fontSize="small">
                <House/>
              </SvgIcon>
            )
          },
          {
            title: localStrings.getStarded,
            path: "/" + dashboardBaseRoute + "/" + getStartedRoute,
            partialMatch: true,
            icon: (
              <SvgIcon fontSize="small">
                <Rocket/>
              </SvgIcon>
            )
          },
          {
            title: localStrings.account,
            path: paths.dashboard.account,
            icon: (
              <SvgIcon fontSize="small">
                <User/>
              </SvgIcon>
            )
          },

        ]
      },
      {
        subheader: localStrings.managment,
        items: appItems
      },
      {
        items: [
          {
            title: localStrings.mediaContent,
            path: config.mediaContentBaseUrl,
            external: true,
            icon: (
              <SvgIcon fontSize="small">
                <Megaphone/>
              </SvgIcon>
            )
          },
        ]
      },
      {
        items: [
          {
            title: localStrings.termsOfService,
            path: "https://www.castreactor.com/termsAndConditions.html",
            external: true,
          },
          {
            title: localStrings.privacyPolicy,
            path: "https://www.castreactor.com/privacyPolicy.html",
            external: true,
          },
        ]
      }
    ];
  }, [t, appItems]);
};
